import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

const badgeVariants = cva(
  'flex items-center border font-medium transition-colors focus:outline-none cursor-default rounded-[50px] leading-none justify-center whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground shadow',
        accent: 'border-transparent bg-accent text-accent-foreground shadow',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow',
        outline: 'text-foreground',
        white: 'bg-white text-black border-white',
      },
      size: {
        default: 'px-2 py-1 text-xs rounded-md',
        sm: 'h-5 px-2 text-xs font-medium',
        md: 'px-2 h-[18px] sm:h-[20px] lg:h-6 lg:px-3 text-[10px] sm:text-xs',
        circle: 'h-6 w-6  text-[10px] rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size, className }))} {...props} />;
}

export { Badge, badgeVariants };
